import { MspCategoryDigitCodesEnum } from 'APIPackage/KnmModule/enums/MspCategoryDigitCodesEnum';
import { MspCodesEnum } from 'APIPackage/KnmModule/enums/MspCodesEnum';

export const mspCodesByMspCategoryDigitCodes: Record<MspCategoryDigitCodesEnum, MspCodesEnum> = {
  [MspCategoryDigitCodesEnum.NON_EXIST]: MspCodesEnum.NON_EXIST,
  [MspCategoryDigitCodesEnum.MICRO]: MspCodesEnum.MICRO,
  [MspCategoryDigitCodesEnum.SMALL]: MspCodesEnum.SMALL,
  [MspCategoryDigitCodesEnum.NORMAL]: MspCodesEnum.NORMAL,
};
